// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1151":"1b73bd38d10f814c","3694":"6755effbf2db112a"}[chunkId] + ".js";
};